var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8255 1.745C7.89862 0.810002 8.8965 0.0870021 9.972 0.325002L10.2656 0.391002C10.7865 0.507002 11.2489 0.847002 11.4041 1.356C11.6516 2.172 12.0038 3.867 11.4739 5.866C11.6395 5.84566 11.8057 5.82865 11.9722 5.815C12.7744 5.75 13.8499 5.743 14.8027 6.025C15.3855 6.198 15.921 6.706 16.1528 7.298C16.3597 7.83 16.3327 8.46 15.8895 9.031C15.9547 9.15 16.0054 9.273 16.0448 9.394C16.1314 9.664 16.1719 9.961 16.1719 10.25C16.1719 10.539 16.1314 10.836 16.0448 11.106C16.0009 11.241 15.9435 11.379 15.8647 11.51C16.0549 11.897 15.9851 12.329 15.8614 12.658C15.7347 12.9829 15.5493 13.2872 15.3124 13.559C15.3731 13.711 15.3979 13.871 15.3979 14.024C15.3979 14.329 15.2978 14.649 15.1132 14.936C14.7375 15.522 13.9916 16 12.9375 16H9C8.31938 16 7.79625 15.919 7.35075 15.782C6.96768 15.6577 6.60162 15.4953 6.2595 15.298L6.2055 15.268C5.6385 14.961 5.08162 14.659 3.879 14.546C3.01725 14.464 2.25 13.846 2.25 13V9C2.25 8.15 3.02063 7.568 3.77663 7.385C4.73175 7.153 5.54737 6.598 6.17512 5.975C6.80512 5.348 7.20337 4.695 7.344 4.336C7.56787 3.761 7.7445 2.797 7.8255 1.746V1.745Z",
    fill: "#FFAB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.9f095b4ec60907078e3830ddc0e43bfb.svg";
export { ForwardRef as ReactComponent };